export default __webpack_public_path__ + "static/media/trans face 1.4a79819d.png";